import {createAction, props} from "@ngrx/store";
import {Serializer, Serializers} from "../../interfaces/serializer";
import {SavedReport} from "../../interfaces/saved-reports";
import {ActionCreator, TypedAction} from '@ngrx/store/src/models';
import {SavedReportComponentObjects} from "../../classes/saved-report-component-object";
import {AdRequestOptions, AdRequestParams} from '../../interfaces/ad-reports';

export const loadSavedReports = createAction('[SAVED_REPORTS] LOAD', props<{ parameters: boolean }>());
export const loadSavedReportsSuccess = createAction('[SAVED_REPORTS] LOAD_SUCCESS', props<{
  savedReports: Serializers<SavedReport>,
  included: Serializers<any>
}>());
export const loadSavedReportsFailure = createAction('[SAVED_REPORTS] LOAD_FAILURE');

export const createSavedReports = createAction('[SAVED_REPORTS] CREATE', props<{
  report: Partial<SavedReport>,
  params: Partial<AdRequestParams>,
  options: Partial<AdRequestOptions>,
  link?: string,
  exit: boolean,
  limit: number
}>());

export const createSavedReportsSuccess = createAction('[SAVED_REPORTS] CREATE_SUCCESS', props<{ report: Serializer<SavedReport>, link?: string, exit: boolean }>());

export const createSavedReportFailure = createAction('[SAVED_REPORTS] CREATE_FAILURE');

export const updateSavedReports = createAction('[SAVED_REPORTS] UPDATE', props<{
  report: Serializer<SavedReport>,
  update: Partial<SavedReport>,
  options: Partial<AdRequestOptions>,
  params: Partial<AdRequestParams>,
  exit: boolean,
  limit: number
}>());
export const updateSavedReportsSuccess = createAction('[SAVED_REPORTS] UPDATE_SUCCESS', props<Partial<{ report: Serializer<SavedReport>, exit: boolean }>>());
export const updateSavedReportFailure = createAction('[SAVED_REPORTS] UPDATE_FAILURE');

export const shareWithLinkSavedReports = createAction('[SAVED_REPORTS] SHARE_WITH_LINK', props<{ report: Serializer<SavedReport>, isPublic: boolean, password: string }>());
export const shareWithLinkSavedReportsSuccess = createAction('[SAVED_REPORTS] SHARE_WITH_LINK_SUCCESS', props<{ report: Serializer<SavedReport> }>());
export const shareWithLinkSavedReportsFailure = createAction('[SAVED_REPORTS] SHARE_WITH_LINK_FAILURE');

export const toggleFavoriteSavedReport: ActionCreator<string, (props: { report: Serializer<SavedReport> }) => TypedAction<string> & { report: Serializer<SavedReport> }> = createAction('[SAVED_REPORTS] TOGGLE_FAVORITE', props<{ report: Serializer<SavedReport> }>());
export const favoriteSavedReport: ActionCreator<string, (props: { report: Serializer<SavedReport>, is_favorite: boolean }) => TypedAction<string> & { report: Serializer<SavedReport>, is_favorite: boolean }> = createAction('[SAVED_REPORTS] FAVORITE', props<{ report: Serializer<SavedReport>, is_favorite: boolean }>());
export const favoriteSavedReportSuccess: ActionCreator<string, (props: { report: Serializer<SavedReport> }) => TypedAction<string> & { report: Serializer<SavedReport> }> = createAction('[SAVED_REPORTS] FAVORITE_SUCCESS', props<{ report: Serializer<SavedReport> }>());
export const favoriteSavedReportFailure: ActionCreator<string, (props: { report: Serializer<SavedReport> }) => TypedAction<string> & { report: Serializer<SavedReport> }> = createAction('[SAVED_REPORTS] FAVORITE_FAILURE', props<{ report: Serializer<SavedReport> }>());


export const deleteSavedReports = createAction('[SAVED_REPORTS] DELETE', props<{ report: Serializer<SavedReport> }>());
export const deleteSavedReportsSuccess = createAction('[SAVED_REPORTS] DELETE_SUCCESS', props<{ report: Serializer<SavedReport> }>());
export const deleteSavedReportFailure = createAction('[SAVED_REPORT] DELETE_FAILURE', props<{ savedReport: Serializer<SavedReport> }>());

export const createSavedReportsStandalone = createAction('[SAVED_REPORTS] CREATE_STANDALONE', props<{ report: Partial<SavedReport> }>());
export const createSavedReportsStandaloneSuccess = createAction('[SAVED_REPORTS] CREATE_STANDALONE_SUCCESS', props<{ report: Serializer<SavedReport> }>());

export const updateSavedReportsStandalone = createAction('[SAVED_REPORTS] UPDATE_STANDALONE', props<{ report: Serializer<SavedReport>, update: Partial<SavedReport> }>());
export const updateSavedReportsStandaloneSuccess = createAction('[SAVED_REPORTS] UPDATE_STANDALONE_SUCCESS', props<{ report: Serializer<SavedReport> }>());

export const initializeSavedReports = createAction('[SAVED_REPORTS] INITIALIZE_REPORTS');
export const initializeSavedReportsSuccess = createAction('[SAVED_REPORTS] INITIALIZE_REPORTS_SUCCESS');
